/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Party, partySchema } from './party';

export interface Data7 {
  party: Party;
}

export const data7Schema: Schema<Data7> = object({
  party: ['Party', lazy(() => partySchema)],
});
